import { createSlice } from "@reduxjs/toolkit";
import socketFactory from '../../../utils/socketFactory.js';

import rainSound from "../../../assets/productivity_audio/Sound_Rain.mp3";
import ventSound from "../../../assets/productivity_audio/Sound_Wind_Autumn.mp3";
import feuSound from "../../../assets/productivity_audio/Sound_fire.mp3";
import foretSound from "../../../assets/productivity_audio/Sound_Forest_Spring.mp3";
import oceanSound from "../../../assets/productivity_audio/Sound_Ocean.mp3";
import orageSound from "../../../assets/productivity_audio/Sound_Rain+Thunder.mp3";

export const MUSIC_OPTIONS = [
    { id: 'rain', name: 'rain', icon: 'rainy', color: "#5890E9", back: "#D7E9EE", src: rainSound },
    { id: 'wind', name: 'wind', icon: 'air', color: "#C7AE0B", back: "#EFEAC6", src: ventSound },
    { id: 'fire', name: 'fire', icon: 'local_fire_department', color: "#E58539", back: "#F2E2D7", src: feuSound },
    { id: 'forest', name: 'forest', icon: 'park', color: "#72B864", back: "#E1EEE0", src: foretSound },
    { id: 'ocean', name: 'ocean', icon: 'water', color: "#68A5B8", back: "#CDF0FF", src: oceanSound },
    { id: 'thunderstorm', name: 'thunderstorm', icon: 'thunderstorm', color: "#745AAD", back: "#E3DEED", src: orageSound },
];


const initialState = {
    sessionView: false,
    subject: null,
    sessionDuration: 0,
    sessionStartTime: null,
    focusSessionActive: false,
    userToUnfocus: null,
    roomToJoin: null,
    isMusicEnabled: false,
    selectedTrack: null,
    targetChair: null,
    targetRoom:null,
    joinBy: null
}

const sessionSlice = createSlice({
    name: "productivitySession",
    initialState,
    reducers: {
        setSessionView: (state, action) => {
            state.sessionView = action.payload;
        },
        closeSessionModal: () => {
            return initialState;
        },
        setSubject: (state, action) => {
            state.subject = action.payload;
        },
        setSessionDuration: (state, action) => {
            state.sessionDuration = action.payload;
        },
        setSessionStartTime: (state, action) => {
            state.sessionStartTime = action.payload;
        },
        setFocusSessionActive: (state, action) => {
            state.focusSessionActive = action.payload;
        },
        RECIEVE_FOCUS_ALERT: (state, action) => {
            const msg = action.payload?.data ?? action.payload;
            if (!msg) return;
            state.roomToJoin = msg.roomId;
            state.userToUnfocus = msg.email;

        },
        setRoomToJoin: (state, action) => {
            state.roomToJoin = action.payload;
        },
        setUserToUnfocus: (state, action) => {
            state.userToUnfocus = action.payload;
        },
        setMusicEnabled: (state, action) => {
            state.isMusicEnabled = action.payload;
            if (action.payload === false) {
                state.selectedTrack = null;
            }
        },
        setPauseMusic: (state, action) => {
            state.isMusicEnabled = action.payload;
        },
        setSelectedTrack: (state, action) => {
            state.selectedTrack = action.payload;
        },
        setTargetChair: (state, action) => {
            state.targetChair = action.payload
        },
        setJoinBy: (state, action) => {
            state.joinBy = action.payload
        },
        setTargetRoom: (state, action) => {
            state.targetRoom = action.payload
        }
        

    }
});

export const {
    setSessionView,
    closeSessionModal,
    setSubject,
    setSessionDuration,
    setSessionStartTime,
    setFocusSessionActive,
    setRoomToJoin,
    setUserToUnfocus,
    RECIEVE_FOCUS_ALERT,
    setMusicEnabled,
    setSelectedTrack,
    setTargetChair,
    setPauseMusic,
    setJoinBy,
    setTargetRoom
} = sessionSlice.actions;


socketFactory.on('inFocusAlert', RECIEVE_FOCUS_ALERT);

export default sessionSlice.reducer;